<template>
  <Stepper v-if="!loading" :fetchedProperty="property" />
</template>

<script>
import { Property } from '@/graphql/queries/property'
import Stepper from '@/components/properties/create/Stepper'

export default {
  data: () => ({
    property: {},
    loading: true
  }),

  components: {
    Stepper
  },

  created () {
    if (this.$route.params.id) {
      this.fetchProperty ()
    } else {
      this.loading = false
    }
  },

  methods: {
    fetchProperty () {
      this.$apollo.query({
        query: Property,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.property = res.data.property

        this.loading = false
      })
    }
  }
}
</script>
